import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import UserMenu from './UserMenu';
import '../components/css/Chat.css';
import axios from 'axios';
import ReactHtmlParser from 'react-html-parser';
import Tools from './Tools';
import { BotIcon, UserIcon, ExecIcon } from './icons/svgIcons';

const ChatReport = (props) => {

    const [data, setData] = useState({});
    const [currentConversation, setCurrentConversation] = useState([]);

    const handleChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const search=()=>{
        getChatConversation(data.searchPattern)
    }

    const getChatConversation = (chatSessionId) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/chatConversation`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: { sessionId: chatSessionId }
        };
        axios(options).then(response => {
            setCurrentConversation(response.data.conversation);
        })
            .catch((error) => {
                console.log("Error:", error.message);
                //setError(error.message);
            });
    }

    useEffect(() => {
        //onload execute ....
    }, []);

    return (
        <div className="mainWrapper">
            <Sidebar />
            <div className="main">
                <div className="headerWrapper">
                    <div className="titleWrapper">
                        <h1>Búsqueda de chats</h1>
                        <span className="upper">Según SessionId</span>
                    </div>
                    <div className="flexWrapper">
                        <UserMenu setInboundConnectedQueues={props.setInboundConnectedQueues} />
                    </div>
                </div>

                <div className="searchWrapper">
                    <input type="search" name="searchPattern" placeholder="Ingrese un patrón de búsqueda..." size="35" autoComplete="off" onChange={handleChange} />
                    <button className='default' onClick={() => search()}>Buscar</button>
                </div>

                {currentConversation.length > 0 ? (
                    <div className="chatWrapper forReport">
                        <div className="chatContainer">
                            {currentConversation.map((message, index) => {
                                return (
                                    <div key={index} className={(message.owner === 'bot' || message.owner === 'exec') ? 'messageRow bot' : message.owner === 'system' ? 'messageRow system ' + message.alertType : 'messageRow user'}>

                                        {message.owner === 'system' || message.owner === 'exec' || message.owner === 'bot' ? (
                                            <span className="message">{ReactHtmlParser(message.message)}</span>
                                        ) : (
                                            <span className="message">{message.message}</span>
                                        )}

                                        <span className='messageInfo'>
                                            { message.owner === 'bot' ? (<BotIcon width="20" height="20" />)
                                            : message.owner === 'user' ? (<UserIcon width="20" height="20" />)
                                            : message.owner === 'exec' ? (<ExecIcon width="20" height="20" />)
                                            : null}
                                            
                                            {message.owner === 'exec' ? (message.executiveName)
                                            : message.owner === 'user' ? ("Usuario")
                                            : message.owner === 'bot' ? ("Bot")
                                            : null}

                                            , &nbsp;
                                            {Tools.fdtCL(message.date)}
                                        </span>

                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ) : null}
                
            </div>
        </div>    
    );

}

export default ChatReport;
